const newLerp = (start, end, t) => (1 - t) * start + t * end;
const newRange = (value, start1, end1, start2, end2) => {
  var t = (value - start1) / (end1 - start1);
  return newLerp(start2, end2, t);
};
export default (scenarios, unit, defaultInvestment, defaultDuration) => ({
  investmentKey: defaultInvestment,
  durationKey: defaultDuration,
  scenarios: [],
  init() {
    scenarios.forEach((item) => {
      Object.values(item).forEach((value) => {
        if (value > this.bestScenario) {
          this.bestScenario = value;
        }
        if (value < this.worstScenario || this.worstScenario === null) {
          this.worstScenario = value;
        }
      });
    });
    this.worstScenario = Math.floor((this.worstScenario * 2) / 2) * 0.9;
    this.bestScenario = Math.ceil(this.bestScenario) * 1.1;
    this.scenarios = scenarios;
    this.unit = unit;
  },
  get scenario() {
    return this.scenarios[this.durationKey];
  },
  range(x) {
    return newRange(
      x,
      this.lowerBound(),
      this.upperBound(),
      this.worstScenario,
      this.bestScenario
    );
  },
  lowerBound() {
    return this.scenario.bad - (this.scenario.good - this.scenario.bad) / 3.5;
  },
  yPos(y) {
    let center = 0.5;
    for (let i = 0; i < y; i++) {
      if (i === this.durationKey) {
        center += 0.4;
        center += 0.6;
      } else {
        center += 0.1;
        center += 0.4;
      }
    }
    return 3 - center;
  },
  upperBound() {
    return this.scenario.good * 1.1;
  },
  currency(val) {
    return "CHF " + Number(Math.round(val * unit)).toLocaleString("de-CH");
  },
  worstScenario: null,
  bestScenario: null,
  investment: {
    ["x-model.number"]: "investmentKey",
  },
  duration: {
    ["x-model.number"]: "durationKey",
  },
  svg: {
    [":viewBox"]: "worstScenario + ' 0 ' + bestScenario + ' 3.6'",
    [":width"]: "bestScenario * 100",
  },
  rect: (val) => ({
    [":d"]: `'M' + range(scenarios[${val}].bad) + ' ' + yPos(${val})+'H' + range(scenarios[${val}].good) + 'v' + (${val} === durationKey ? -0.3 : -0.1) + 'H' + range(scenarios[${val}].bad) + 'Z'`,
  }),
});
